import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { Stack, mergeStyles } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton } from '../../components';
import { CampaignSelectionDoubleListBox } from './campaign-selection-double-list-box/index';
import { AUTO_BIDDING_FEATURE_IDS } from '../../constants';

const campaignSelectionStyles = mergeStyles({
  marginTop: 12,
  marginBottom: 24,
});

const nextButtonStyles = mergeStyles({
  marginRight: 8,
});

export const SpecificCampaignSelection = ({
  onNext, onBack, onClose, selectedCampaigns, setSelectedCampaigns, coupon,
}) => {
  const i18n = useContext(I18nContext);

  const anySelectedCampaigns = useMemo(() => _.isArray(selectedCampaigns) && selectedCampaigns.length > 0, [selectedCampaigns]);

  const descriptionText = useMemo(() => {
    switch (coupon.FeatureId) {
      case AUTO_BIDDING_FEATURE_IDS.MAX_CLICKS:
        return i18n.getString(_TL_('You can search and select the campaign(s) to which you want to apply a maximize clicks bid strategy.'));
      case AUTO_BIDDING_FEATURE_IDS.MAX_CONVERSIONS:
        return i18n.getString(_TL_('You can search and select the campaign(s) to which you want to apply a maximize conversions bid strategy.'));
      default:
        return '';
    }
  }, [coupon.FeatureId, i18n]);

  return (
    <>
      <div>{descriptionText}</div>
      <div className={classNames(campaignSelectionStyles, 'specific-campaign-selection')} >
        <CampaignSelectionDoubleListBox coupon={coupon} onSelectionChange={setSelectedCampaigns} />
      </div>
      <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className="footer">
        <DefaultButton text="Back" onClick={onBack} />
        <Stack horizontal horizontalAlign="end" >
          <PrimaryButton text={i18n.getString(_TL_('Continue'))} onClick={onNext} disabled={!anySelectedCampaigns} className={classNames(nextButtonStyles, 'next-button')} />
          <DefaultButton text={i18n.getString(_TL_('Close'))} onClick={onClose} className="close-button" />
        </Stack>
      </Stack>
    </>
  );
};

SpecificCampaignSelection.propTypes = {
  coupon: PropTypes.shape({
    FeatureId: PropTypes.number.isRequired,
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  selectedCampaigns: PropTypes.shape({
    length: PropTypes.number,
  }).isRequired,
  setSelectedCampaigns: PropTypes.func.isRequired,
};
